import React, { useState } from 'react';
import { motion } from 'framer-motion';

const WipeAdvertisement = ({ advertising, setShowComponent }) => {
  const [hideVideo, setHideVideo] = useState({});

  function playerEnded() {
    setHideVideo({ opacity: 0 });
    setShowComponent({ opacity: 1 });
  }

  return (
    <motion.video
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        objectFit: 'cover',
        zIndex: 100,
        pointerEvents: 'none'
      }}
      animate={hideVideo}
      width="100%"
      height="100%"
      src={advertising}
      key={advertising}
      autoPlay
      muted
      onEnded={playerEnded}
    ></motion.video>
  );
};

export { WipeAdvertisement };
